import React from "react";

export default function MPStatistic() {
  return <div>MPStatistic</div>;
}
